import React, { useCallback, useEffect, useState } from "react";
import "../css/navbar.css";
import menuitems from "../api/menuitems";
import { useAuth } from "../contexts/AuthContext";
import { Link } from "react-router-dom";
import ProfileWidget from "./ProfileWidget";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { roles } from "../firebase.collection";
import { CircularProgress } from "@mui/material";

import { useMediaQuery } from "react-responsive";

export default function Navbar(props) {
  const { currentUser } = useAuth();
  const [activeLink, setActiveLink] = useState(props.linkActive);
  const [userRole, setUserRole] = useState("");
  const [userIdState] = useState(
    currentUser ? currentUser.uid : ""
  );
  const [loading, setLoading] = useState(true);

  const isSmallScreen = useMediaQuery({ query: "(max-width: 1300px)" });

  function handleLinkClick(linkId) {
    setActiveLink(linkId === activeLink ? null : linkId);
  }

  const queryRole = useCallback(() => {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
          setLoading(false);
        } else {
          console.log("Problem loading roles");
        }
      }
    );
  }, [userIdState]);

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
  }, [currentUser, queryRole]);

  const upperMenuItems = menuitems.filter(
    (item) =>
      ![
        "My Profile",
        "Roles",
        "Staff contacts",
        "Export Data",
        "Email Templates",
      ].includes(item.name)
  );

  const lowerMenuItems = menuitems.filter((item) =>
    [
      "My Profile",
      "Roles",
      "Staff contacts",
      "Export Data",
      "Email Templates",
    ].includes(item.name)
  );

  return (
    <div className="navbar-container">
      <div className="navbar-top-group">
        <div className="profile-widget-component">
          <ProfileWidget userRole={userRole} />
        </div>
        <div className="menu-items-container">
          {loading ? (
            <div className="circular-progress-container">
              <CircularProgress />
              <div className="loading-text">Loading, please wait...</div>
            </div>
          ) : (
            <>
              {(() => {
                const groupItems = (list) => {
                  const groups = [];
                  let current = [];
                  list.forEach((item) => {
                    current.push(item);
                    if (item.gapAfter) {
                      groups.push(current);
                      current = [];
                    }
                  });
                  if (current.length) groups.push(current);
                  return groups;
                };
                const filtered = upperMenuItems.filter((item) =>
                  item.roles.includes(userRole)
                );
                return groupItems(filtered).map((group, gi) => (
                  <div className="menu-group" key={gi}>
                    {group.map((item, index) => (
                      <div className="sidebar-title" key={index}>
                        <div className="icon-menu-v2">{item.icon}</div>
                        <Link
                          className={`link-navbar ${
                            item.id === activeLink ? "active" : ""
                          }`}
                          to={item.link}
                          onClick={() => handleLinkClick(item.id)}
                        >
                          <div
                            className={`menu-title ${
                              item.id === activeLink ? "active" : ""
                            } ${isSmallScreen ? "small-screen" : ""}`}
                          >
                            {item.name}
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                ));
              })()}
              <div className="menu-separator"></div>
              {(() => {
                const filtered = lowerMenuItems.filter((item) =>
                  item.roles.includes(userRole)
                );
                return (
                  <div className="menu-group">
                    {filtered.map((item, index) => (
                      <div className="sidebar-title" key={index}>
                        <div className="icon-menu">{item.icon}</div>
                        <Link
                          className={`link-navbar ${
                            item.id === activeLink ? "active" : ""
                          }`}
                          to={item.link}
                          onClick={() => handleLinkClick(item.id)}
                        >
                          <div
                            className={`menu-title ${
                              item.id === activeLink ? "active" : ""
                            } ${isSmallScreen ? "small-screen" : ""}`}
                          >
                            {item.name}
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </>
          )}
        </div>
      </div>
      <div className="navbar-bottom-group">
        {/* InternetCheck removed per request */}
      </div>
    </div>
  );
}
